// removed by extract-text-webpack-plugin
module.exports = {"root":"menu-profile--root--cjsQIuhd","show":"menu-profile--show--3S4pei14","button-container":"menu-profile--button-container--10tbcWGG","buttonContainer":"menu-profile--button-container--10tbcWGG","data-container":"menu-profile--data-container--2VNl1V4C","dataContainer":"menu-profile--data-container--2VNl1V4C","header":"menu-profile--header--2ThhmwCF","Select-control":"menu-profile--Select-control--VcC5tYfT","selectControl":"menu-profile--Select-control--VcC5tYfT","title":"menu-profile--title--39zjQY7h"};


//////////////////
// WEBPACK FOOTER
// ./components/header/menu-profile/styles.less
// module id = ./components/header/menu-profile/styles.less
// module chunks = 0